import React from 'react';
import {MainGridTextContainer} from "./mainGridTextStyles";

function MainGridText(props) {
    return (
        <MainGridTextContainer>
            <div> ▪ 한화디펜스</div>
            <div> ▪ 한국전기연구원 KERI</div>
            <div> ▪ LIG 넥스원</div>
            <div> ▪ EO Technics</div>
            <div> ▪ 한국생산기술연구원 KITECH</div>
            <div> ▪ 대한광통신</div>

        </MainGridTextContainer>);
}

export default MainGridText;